/*
 * Eu Perfumista: lista de desejos própria (substitui o Wishlist Hero).
 * A lista fica no navegador do cliente (localStorage). Para levar a outro aparelho,
 * o cliente usa o link de compartilhar (/pages/wish?itens=handle1,handle2).
 *
 * Eventos publicados para os Pixels personalizados (Configurações > Eventos do cliente):
 *   ep_lista_adicionar, ep_lista_remover, ep_lista_carrinho,
 *   ep_lista_compartilhar, ep_lista_visualizar
 * Itens levados ao carrinho pela página da lista recebem a propriedade _lista_desejos = sim,
 * que aparece no pedido.
 */
(function () {
  'use strict';

  var KEY = 'ep_lista_desejos_v1';
  var PAGE = '/pages/wish';
  var PROP = '_lista_desejos';
  var MAX = 200;

  /* ---------- armazenamento ---------- */

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) return [];
      return list.filter(function (item) { return item && typeof item.h === 'string' && item.h; });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) { /* modo privado ou armazenamento cheio: a lista só não persiste */ }
  }

  function has(handle) {
    return read().some(function (item) { return item.h === handle; });
  }

  function add(handle, productId) {
    var list = read();
    if (list.some(function (item) { return item.h === handle; })) return false;
    list.unshift({ h: handle, id: productId || null, t: Date.now() });
    write(list);
    return true;
  }

  function remove(handle) {
    write(read().filter(function (item) { return item.h !== handle; }));
  }

  /* ---------- análises ---------- */

  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (e) { /* análise nunca pode quebrar a página */ }
  }

  /* ---------- interface ---------- */

  /* Só escreve no DOM quando algo muda, para o MutationObserver abaixo não entrar em ciclo. */
  function setText(el, text) {
    if (el.textContent !== text) el.textContent = text;
  }

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function paint() {
    var saved = read().map(function (item) { return item.h; });
    var count = String(saved.length);

    document.querySelectorAll('[data-ep-wl]').forEach(function (button) {
      var active = saved.indexOf(button.getAttribute('data-ep-wl')) !== -1;
      if (button.classList.contains('is-active') !== active) button.classList.toggle('is-active', active);
      setAttr(button, 'aria-pressed', active ? 'true' : 'false');
      setAttr(button, 'aria-label', active ? 'Remover da lista de desejos' : 'Adicionar à lista de desejos');

      var label = button.querySelector('[data-ep-wl-label]');
      if (label) {
        setText(label, active
          ? button.getAttribute('data-ep-wl-on') || 'Na sua lista de desejos'
          : button.getAttribute('data-ep-wl-off') || 'Adicionar à lista de desejos');
      }
    });

    document.querySelectorAll('[data-ep-wl-count]').forEach(function (badge) {
      setText(badge, count);
      if (badge.hidden !== (count === '0')) badge.hidden = count === '0';
    });
  }

  var toastTimer;

  function toast(html) {
    var el = document.querySelector('.ep-wl-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ep-wl-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = html;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3500);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ep-wl]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var handle = button.getAttribute('data-ep-wl');
    var productId = Number(button.getAttribute('data-ep-wl-id')) || null;
    var origin = button.getAttribute('data-ep-wl-origem') || 'card';

    if (has(handle)) {
      remove(handle);
      track('ep_lista_remover', { handle: handle, product_id: productId, origem: origin });
      toast('Removido da sua lista de desejos.');
    } else {
      add(handle, productId);
      track('ep_lista_adicionar', { handle: handle, product_id: productId, origem: origin });
      toast('Adicionado à sua lista de desejos. <a href="' + PAGE + '">Ver lista</a>');
    }

    paint();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === KEY) paint();
  });

  /* Coleções com filtros, visualização rápida e "vistos recentemente" inserem cards depois do carregamento. */
  var paintQueued = false;
  new MutationObserver(function () {
    if (paintQueued) return;
    paintQueued = true;
    requestAnimationFrame(function () { paintQueued = false; paint(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- página da lista ---------- */

  var money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  function formatMoney(cents) {
    return money.format((cents || 0) / 100);
  }

  function esc(text) {
    return String(text == null ? '' : text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function imageUrl(src, width) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });
  }

  function shareUrl(handles) {
    return window.location.origin + PAGE + '?itens=' + handles.map(encodeURIComponent).join(',');
  }

  function cardHtml(product, shared) {
    var firstAvailable = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var options = product.variants.map(function (variant) {
      return '<option value="' + variant.id + '" data-price="' + variant.price + '"' +
        (variant.id === firstAvailable.id ? ' selected' : '') + (variant.available ? '' : ' disabled') + '>' +
        esc(variant.title === 'Default Title' ? product.title : variant.title.replace(' gramas', ' g')) + ' · ' +
        formatMoney(variant.price) + (variant.available ? '' : ' (esgotado)') + '</option>';
    }).join('');

    return '' +
      '<article class="ep-wl-card" data-ep-wl-card="' + esc(product.handle) + '">' +
        '<a class="ep-wl-card__image" href="/products/' + esc(product.handle) + '">' +
          (product.featured_image ? '<img src="' + esc(imageUrl(product.featured_image, 360)) + '" alt="' + esc(product.title) + '" loading="lazy" width="360" height="360">' : '') +
        '</a>' +
        '<div class="ep-wl-card__body">' +
          '<a class="ep-wl-card__title" href="/products/' + esc(product.handle) + '">' + esc(product.title) + '</a>' +
          '<p class="ep-wl-card__price" data-ep-wl-price>' + formatMoney(firstAvailable.price) + '</p>' +
          (product.variants.length > 1 ? '<select class="ep-wl-card__select" data-ep-wl-variant aria-label="Escolha o tamanho">' + options + '</select>'
            : '<input type="hidden" data-ep-wl-variant value="' + firstAvailable.id + '">') +
          '<div class="ep-wl-card__actions">' +
            (product.available
              ? '<button type="button" class="button button--primary button--small" data-ep-wl-cart>Adicionar ao carrinho</button>'
              : '<button type="button" class="button button--disabled button--small" disabled>Esgotado</button>') +
            (shared ? '' : '<button type="button" class="ep-wl-card__remove link" data-ep-wl-remove>Remover</button>') +
          '</div>' +
        '</div>' +
      '</article>';
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (err) { throw err; });
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
      return response.json();
    });
  }

  function initPage(root) {
    var params = new URLSearchParams(window.location.search);
    var sharedParam = params.get('itens');
    var shared = !!sharedParam;
    var handles = shared
      ? sharedParam.split(',').map(function (h) { return h.trim(); }).filter(Boolean).slice(0, MAX)
      : read().map(function (item) { return item.h; });

    var grid = root.querySelector('[data-ep-wl-grid]');
    var empty = root.querySelector('[data-ep-wl-empty]');
    var toolbar = root.querySelector('[data-ep-wl-toolbar]');
    var sharedBanner = root.querySelector('[data-ep-wl-shared]');
    var summary = root.querySelector('[data-ep-wl-summary]');
    var loaded = [];

    function refreshSummary() {
      var n = grid.querySelectorAll('[data-ep-wl-card]').length;
      summary.textContent = n === 1 ? '1 item' : n + ' itens';
      empty.hidden = n > 0;
      toolbar.hidden = n === 0;
    }

    if (!handles.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      toolbar.hidden = true;
      return;
    }

    grid.setAttribute('aria-busy', 'true');

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      loaded = products.filter(Boolean);

      /* produto apagado ou despublicado: sai da lista do próprio cliente */
      if (!shared && loaded.length !== handles.length) {
        var alive = loaded.map(function (p) { return p.handle; });
        write(read().filter(function (item) { return alive.indexOf(item.h) !== -1; }));
        paint();
      }

      grid.innerHTML = loaded.map(function (p) { return cardHtml(p, shared); }).join('');
      grid.removeAttribute('aria-busy');

      if (shared && sharedBanner) sharedBanner.hidden = false;
      refreshSummary();

      track('ep_lista_visualizar', { itens: loaded.length, compartilhada: shared });
    });

    root.addEventListener('change', function (event) {
      var select = event.target.closest('[data-ep-wl-variant]');
      if (!select || select.tagName !== 'SELECT') return;
      var option = select.options[select.selectedIndex];
      var card = select.closest('[data-ep-wl-card]');
      card.querySelector('[data-ep-wl-price]').textContent = formatMoney(Number(option.getAttribute('data-price')));
    });

    root.addEventListener('click', function (event) {
      var cartButton = event.target.closest('[data-ep-wl-cart]');
      var removeButton = event.target.closest('[data-ep-wl-remove]');
      var action = event.target.closest('[data-ep-wl-action]');

      if (cartButton) {
        var card = cartButton.closest('[data-ep-wl-card]');
        var variantId = Number(card.querySelector('[data-ep-wl-variant]').value);
        var properties = {};
        properties[PROP] = 'sim';
        cartButton.disabled = true;

        addToCart([{ id: variantId, quantity: 1, properties: properties }]).then(function () {
          cartButton.textContent = 'Adicionado ✓';
          track('ep_lista_carrinho', { handle: card.getAttribute('data-ep-wl-card'), variant_id: variantId, itens: 1 });
          toast('Item no carrinho. <a href="/cart">Ver carrinho</a>');
        }).catch(function (err) {
          cartButton.disabled = false;
          toast(esc((err && err.description) || 'Não foi possível adicionar ao carrinho.'));
        });
        return;
      }

      if (removeButton) {
        var removedCard = removeButton.closest('[data-ep-wl-card]');
        var handle = removedCard.getAttribute('data-ep-wl-card');
        remove(handle);
        track('ep_lista_remover', { handle: handle, origem: 'pagina-lista' });
        removedCard.remove();
        refreshSummary();
        paint();
        return;
      }

      if (!action) return;
      var kind = action.getAttribute('data-ep-wl-action');
      var currentHandles = Array.prototype.map.call(grid.querySelectorAll('[data-ep-wl-card]'), function (c) {
        return c.getAttribute('data-ep-wl-card');
      });

      if (kind === 'todos-carrinho') {
        var props = {};
        props[PROP] = 'sim';
        var items = Array.prototype.map.call(grid.querySelectorAll('[data-ep-wl-card]'), function (c) {
          var button = c.querySelector('[data-ep-wl-cart]');
          if (!button) return null;
          return { id: Number(c.querySelector('[data-ep-wl-variant]').value), quantity: 1, properties: props };
        }).filter(Boolean);
        if (!items.length) return;

        action.disabled = true;
        addToCart(items).then(function () {
          track('ep_lista_carrinho', { itens: items.length, todos: true });
          toast(items.length + ' itens no carrinho. <a href="/cart">Ver carrinho</a>');
        }).catch(function (err) {
          toast(esc((err && err.description) || 'Não foi possível adicionar todos os itens.'));
        }).then(function () { action.disabled = false; });
      }

      if (kind === 'copiar') {
        var url = shareUrl(currentHandles);
        var done = function () { toast('Link copiado. Abra em outro aparelho ou envie para alguém.'); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copie o link:', url); });
        } else {
          window.prompt('Copie o link:', url);
        }
        track('ep_lista_compartilhar', { canal: 'link', itens: currentHandles.length });
      }

      if (kind === 'whatsapp') {
        var text = 'Minha lista de desejos na Eu Perfumista: ' + shareUrl(currentHandles);
        window.open('https://wa.me/?text=' + encodeURIComponent(text), '_blank', 'noopener');
        track('ep_lista_compartilhar', { canal: 'whatsapp', itens: currentHandles.length });
      }

      if (kind === 'salvar-todos') {
        var before = read().length;
        currentHandles.slice().reverse().forEach(function (h) { add(h, null); });
        var saved = read().length - before;
        track('ep_lista_adicionar', { origem: 'link-compartilhado', itens: saved });
        paint();
        window.location.href = PAGE;
      }
    });
  }

  function init() {
    paint();
    var root = document.querySelector('[data-ep-wl-page]');
    if (root) initPage(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
